import { Component, inject } from '@angular/core';
import { GeneticMaterialCrossingTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialCrossingTypeCreateDto,
  GeneticMaterialCrossingTypeDto,
  GeneticMaterialCrossingTypeExcelDownloadDto,
  GeneticMaterialCrossingTypeUpdateDto,
} from '../proxy/general/dtos/genetic-material-crossing-type';
import { GENETICMATERIALCROSSINGTYPE_CONFIG, GENETICMATERIALCROSSINGTYPE_FIELDS } from './genetic-material-crossing-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material-crossing-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialCrossingTypeService, ConfirmationService],
  templateUrl: './genetic-material-crossing-type.html',
  styleUrl: './genetic-material-crossing-type.scss',
})
export class GeneticMaterialCrossingType extends BaseCrudComponent<
  GeneticMaterialCrossingTypeDto,
  GeneticMaterialCrossingTypeCreateDto,
  GeneticMaterialCrossingTypeUpdateDto,
  GeneticMaterialCrossingTypeExcelDownloadDto
> {
  service = inject(GeneticMaterialCrossingTypeService);
  config = GENETICMATERIALCROSSINGTYPE_CONFIG;
  fields = GENETICMATERIALCROSSINGTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialCrossingTypeDto): GeneticMaterialCrossingTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterialCrossingType';
  }
}
